import { useField } from 'formik'
import PasswordInput from './PasswordInput'

const FormikPasswordInput = ({ label, required, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <PasswordInput
      {...field}
      {...props}
      label={label}
      required={required}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  )
}

export default FormikPasswordInput

